import {User} from '../../Auth/User';

export function isOptionDisabled(option: any) {
    switch (option) {
        case 'F&G':
        case 'Transamerica':
        case 'Ameritas: FLX Living Benefits Term':
        case 'North American: Term - ADDvantage':
        case 'National Life Group: LSW Term':
        case 'Assurity Life Insurance Company: Term Life Insurance':
        case 'Client requested (Higher cap, option other than S&P, other)':
            return true;
        case 'National Life Group':
            return !['nikkif@getamplifylife.com', 'kc@getamplifylife.com'].includes(User.Info.email);
        default:
            return false;
    }
}
